import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="border-b border-border bg-gradient-to-br from-primary/5 to-accent/5">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl">
              Disclaimer
            </h1>
            <p className="text-lg text-muted-foreground">
              Last updated: November 11, 2025
            </p>
          </div>
        </div>
      </section>

      {/* Disclaimer Content */}
      <section className="container mx-auto px-4 py-16 md:py-24">
        <div className="mx-auto max-w-4xl">
          <Card>
            <CardContent className="prose prose-slate max-w-none pt-6 dark:prose-invert">
              <div className="space-y-8">
                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">1. General Information</h2>
                  <p className="text-muted-foreground">
                    The information provided on RunoBlog (www.runoblog.site) is published in good faith and for general informational and educational purposes only.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    While we strive to ensure all content is accurate and up-to-date, RunoBlog makes no warranties or representations regarding completeness, reliability, or accuracy. Any action you take based on the information found on this website is strictly at your own risk.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    RunoBlog will not be liable for any losses or damages (direct or indirect) in connection with the use of our website or the information provided.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">2. Professional Advice Disclaimer</h2>
                  <p className="text-muted-foreground">
                    All content on RunoBlog — including articles, guides, tutorials, or videos — is created for educational purposes only.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    It should not be considered professional advice, including but not limited to:
                  </p>
                  <ul className="mt-2 space-y-2 text-muted-foreground">
                    <li>Legal advice</li>
                    <li>Financial advice</li>
                    <li>Medical advice</li>
                    <li>Technical or business advice</li>
                  </ul>
                  <p className="mt-4 text-muted-foreground">
                    Always seek guidance from a qualified professional before making decisions based on information found on this website.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">3. External Links Disclaimer</h2>
                  <p className="text-muted-foreground">
                    Our website may contain links to external or third-party websites that are not owned or controlled by RunoBlog.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    While we strive to provide quality links to useful and ethical websites, we have no control over the content, privacy policies, or practices of these external sites.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    The inclusion of any external link does not imply endorsement or guarantee of the information found there. Visitors should use discretion and review the terms and privacy policies of any third-party website they visit.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">4. Affiliate and Advertising Disclaimer</h2>
                  <p className="text-muted-foreground">
                    Some links on our site may be affiliate links. This means we may earn a commission if you click a link or make a purchase through it — at no additional cost to you.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    We also display ads through Google AdSense, Adsterra, and other ad partners. These ads (including popunder ads) are automatically served and may be personalized based on your interests.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    We only promote products, services, or brands that we believe are useful, relevant, and trustworthy.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    For more information, please review our:
                  </p>
                  <ul className="mt-2 space-y-1 text-muted-foreground">
                    <li><a href="/disclosure" className="text-primary hover:underline">Disclosure & Affiliate Policy</a></li>
                    <li><a href="/privacy" className="text-primary hover:underline">Privacy Policy</a></li>
                  </ul>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">5. Comments and User-Generated Content</h2>
                  <p className="text-muted-foreground">
                    We encourage readers to share opinions and experiences in the comment sections. However, the views and opinions expressed in comments are those of the authors only and do not necessarily reflect the official policy or position of RunoBlog.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    We reserve the right to moderate or remove comments that are offensive, misleading, or violate our policies.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">6. Consent</h2>
                  <p className="text-muted-foreground">
                    By using our website, you hereby consent to our disclaimer and agree to its terms.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">7. Updates</h2>
                  <p className="text-muted-foreground">
                    This Disclaimer may be updated from time to time. Any changes will be posted on this page with an updated "Last Updated" date.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">8. Contact Us</h2>
                  <p className="text-muted-foreground">
                    If you have any questions about this Disclaimer, please contact us at:
                  </p>
                  <ul className="mt-4 space-y-2 text-muted-foreground">
                    <li>📧 Email: runoux.dev@gmail.com</li>
                    <li>🌐 Website: <a href="https://www.runoblog.site" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://www.runoblog.site</a></li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Disclaimer;
